const translations = {
  fr: {
    promotions: {
      timeSlot: 'Plage',
      from: 'du',
      to: 'au',
      amount: 'Quantité',
      cost: 'Prix',
      discount: 'Rabais',
      promotion: 'Promotion',
      discounted: 'de rabais',
      nbOfSpots: 'Nombre de spots',
      view: 'Voir',
      accept: 'Accepter',
      hasNewPromotions: 'Vous avez {{count}} nouvelles promotions',
      offerWillExpireAt: 'Cette offre expirera le {{date, dddd Do MMMM YYYY}}',
      decline: 'Refuser',
      promotionHasBeenAccepted: 'La promotion a été acceptée',
      promotionHasBeenDeclined: 'La promotion a été refusée',
      errorAcceptingPromotion: 'Une erreur est survenue lors de l\'acceptation de la promotion',
      errorDecliningPromotion: 'Une erreur est survenue lors du rejet de la promotion',
    },
  },
  en: {
    promotions: {
      timeSlot: 'Time slot',
      from: 'from',
      to: 'to',
      amount: 'Amount',
      cost: 'Cost',
      discount: 'Discount',
      promotion: 'Promotion',
      discounted: 'off',
      nbOfSpots: 'Nombre de spots',
      view: 'View',
      accept: 'Accept',
      hasNewPromotions: 'You have {{count}} new promotions',
      offerWillExpireAt: 'This offer will expire at {{date, dddd Do MMMM YYYY}}',
      decline: 'Decline',
      promotionHasBeenAccepted: 'The promotion has been accepted',
      promotionHasBeenDeclined: 'The promotion has been declined',
      errorAcceptingPromotion: 'An error occured when accepting the promotion',
      errorDecliningPromotion: 'An error occured when declining the promotion',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/i18n/promotions.js